module.exports = __webpack_public_path__ + "img/success-status.902c2c2d.svg";